import { Box, colors, Typography } from "@mui/material";
import React from "react";
import theme from "../../Constants/theme";
import heroVideo from "../../Assets/hero.mp4";
import bgImage from "../../Assets/bgimage.png";

const ArtPanel = () => {
  return (
    <Box
      sx={{
        flex: 2,
        position: "relative",
        overflow: "hidden",
        display: { xs: "none", md: "block" },
        bgcolor: theme.main.secondaryBlue,
      }}
    >
      {/* fallback image */}
      <img
        src={bgImage}
        alt=""
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* background video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 1,
          filter: "brightness(0.6)",
        }}
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* overlay text */}
      <Box
        sx={{
          position: "absolute",
          inset: 0, // top:0, right:0, bottom:0, left:0
          zIndex: 2, // above video
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center", // center multiline text
          px: 3, // horizontal padding on very large screens
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mb: 1,
            fontSize: { xs: "2rem", md: "3rem" },
            lineHeight: 1.2,
          }}
        >
          Build AI Applications with your data
        </Typography>
        <Typography
          variant="h4"
          component="p"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.5rem", md: "2.5rem" },

            background: "linear-gradient(90deg, #3550FF 0%, #9B3FFF 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",

            // (Optionally for non-WebKit browsers:)
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          100x faster
        </Typography>
      </Box>
    </Box>
  );
};

export default ArtPanel;
